
import * as React from 'react';
import * as Plyr from 'react-plyr';

type VideoProvider = 'youtube' | 'vimeo';

export type VideoLightboxProps = {
  videoURL: string;
  provider: VideoProvider;
  buttonText: string;
  closeText: string;
}
class VideoLightbox extends React.Component<VideoLightboxProps, never> {
  private containerRef: any;
  private plyrRef: any;

  constructor(props: VideoLightboxProps) {
    super(props);
    this.containerRef = React.createRef();
    this.plyrRef = React.createRef();
  }
  
  playVideo() {
    document.documentElement.classList.add('lightbox--open');
    this.containerRef.classList.remove('lightbox--hidden');
    setTimeout(() => {
      this.plyrRef.play();
    }, 0);
  }
  
  pauseVideo() {
    document.documentElement.classList.remove('lightbox--open');
    this.containerRef.classList.add('lightbox--hidden');
    this.plyrRef.pause();
  }

  render(): React.ReactNode {
    const {
      buttonText,
      closeText,
      provider,
      videoURL,
    } = this.props
    return (
      <>      
        <button 
          onClick={() => this.playVideo()} 
          className="button button--video">
            <span className="button__icon" />
            <span className="button__text">{ buttonText }</span>
        </button>
        <aside className="lightbox lightbox--hidden" ref={ref => this.containerRef = ref}>
          <div className="lightbox__inner">
            <div className="lightbox__bg" onClick={() => this.pauseVideo()} />
            <nav className="lightbox__nav">
              <div className="lightbox__nav-inner">
              <button
                onClick={() => this.pauseVideo()}
                className="lightbox__close"
              >
                <span className="sr-text">{closeText}</span>
                <svg aria-hidden="true"><use xlinkHref="#icon--close-circled" /></svg>
              </button>
              </div>
            </nav>
            <div className="lightbox__visual">
              <div className="lightbox__video">
                <Plyr
                  ref={ref => this.plyrRef = ref} 
                  type={provider}
                  videoId={videoURL}
                />
              </div>
            </div>
          </div>                  
        </aside>
      </>
    )
  }
}

export default VideoLightbox;